"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVerboseTypeValidationFunction = exports.getTypeValidationFunction = void 0;
const getTypeValidationFunction = (schema) => {
    return (x, verbose = false) => {
        const result = schema.safeParse(x);
        if (verbose && !result.success) {
            console.error(result.error);
        }
        return result.success;
    };
};
exports.getTypeValidationFunction = getTypeValidationFunction;
/**
 * @deprecated Use getTypeValidationFunction instead
 */
const getVerboseTypeValidationFunction = (schema) => {
    return (x) => {
        const result = schema.safeParse(x);
        if (!result.success) {
            console.error(result.error);
        }
        return result.success;
    };
};
exports.getVerboseTypeValidationFunction = getVerboseTypeValidationFunction;
//# sourceMappingURL=type_validation_helpers.js.map